import { module } from 'modujs'

export default class extends module {
    constructor(m) {
        super(m)

        // DOM
        this.$page = document.getElementById('page')

        // Events
        this.events = {
            click: {
                button: 'onClick'
            }
        }
    }

    onClick(e) {
        e.preventDefault()

        const $focusables = this.$page.querySelectorAll('button:not([disabled]), [href], input, select, textarea, [tabindex]:not([tabindex="-1"])')
        const $target = $focusables.length > 0 ? $focusables[0] : this.$page

        if($target) {
            this.call('scrollTo', {
                target: $target,
            }, 'Scroll')

            $target.focus()
        }
    }
}
